const MATERIAL_HOVER_LABELS = {
    '/db/Icons/dungeon_drops/material_thumbnail_paradisos.webp': 'Dragon God Paradiso',
    '/db/Icons/dungeon_drops/material_thumbnail_heroSoul.webp': 'Awoken Soul',
};

function formatMaterialName(fileStem) {
    let name = fileStem
        .replace(/^material_thumbnail_/i, '')
        .replace(/^frag/i, '');

    name = name
        .replace(/[_-]+/g, ' ')
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/([A-Za-z])(\d)/g, '$1 $2')
        .replace(/(\d)([A-Za-z])/g, '$1 $2')
        .trim();

    if (!name) {
        return '';
    }

    return name.replace(/\b([a-zA-Z])/g, (ch) => ch.toUpperCase());
}

export function getMaterialHoverLabel(mat, index) {
    const hover = mat?.[`hover${index}`];
    if (typeof hover === 'string' && hover.trim()) {
        return hover.trim();
    }

    const src = mat?.[`mat${index}`];
    if (!src) {
        return '';
    }

    if (MATERIAL_HOVER_LABELS[src]) {
        return MATERIAL_HOVER_LABELS[src];
    }

    const file = src.split('/').pop().replace(/\.[^.]+$/, '');
    return formatMaterialName(file);
}
